export const getRoles = (action) => {
    return {
        roles: ['admin', 'consultant', 'external']
    }
}